module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("6d87Q"))).then(() => parcelRequire('9e8an'));